import { h, Component, ComponentChildren } from 'preact'

interface Props {
  children: ComponentChildren
}

export default class extends Component<Props> {
  render ({ children }: Props) {
    return (
      <form className='o-form'>
        {children}
      </form>
    )
  }
}
